import auth from "@irati/auth/streams/auth"

export default async () => {
  try {
    const termsAndConditionsUrl = auth.get().dealPackage.termsAndConditionsUrl

    return termsAndConditionsUrl
  } catch (e) {
    return ""
  }
}
